export default {

    MYSQL: 'mysql',
    MYSQL_CN: 'mysql-cn'
}